import React, { useState, useEffect } from 'react';
import {
	Stack,
	Typography,
	TableContainer,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	IconButton
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import MediumModal from '../../../components/modals/MediumModal';
import PreviewModal from '../../../components/modals/PreviewModal';
import { getToken } from '../../../api/Account';
import { simpleMessage } from '../../../helpers/Helpers';
import { getTransferenciasDelDiaByGestorAsync } from '../../../api/ArqueoCaja';

const formatter = new Intl.NumberFormat('es-NI', {
	style: 'currency',
	currency: 'NIO'
});

// Coincide con Quotes.EntidadBancaria: 1=Lafise, 2=Billetera Móvil
const ENTIDADES = {
	1: 'Lafise',
	2: 'Billetera Móvil'
};

const TransferenciasGestorModal = ({ open, onClose, gestorId, fecha }) => {
	const token = getToken();

	const [transferenciaList, setTransferenciaList] = useState([]);

	const [previewOpen, setPreviewOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');

	useEffect(() => {
		if (open && gestorId) {
			loadTransferencias();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open, gestorId, fecha]);

	const loadTransferencias = async () => {
		const result = await getTransferenciasDelDiaByGestorAsync(
			token,
			gestorId,
			moment(fecha).format('YYYY-MM-DD')
		);
		if (!result.statusResponse) {
			simpleMessage(result.error, 'error');
			return;
		}
		setTransferenciaList(result.data.result);
	};

	const verComprobante = (imageUrl) => {
		setSelectedImage(imageUrl);
		setPreviewOpen(true);
	};

	const total = transferenciaList.reduce((sum, t) => sum + t.totalRecibido, 0);

	return (
		<MediumModal titulo="Abonos por Transferencia" isVisible={open} setVisible={onClose}>
			<Stack spacing={2}>
				<TableContainer>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Cliente</TableCell>
								<TableCell align="center">Crédito</TableCell>
								<TableCell align="center">Entidad</TableCell>
								<TableCell align="center">Hora</TableCell>
								<TableCell align="center">Monto</TableCell>
								<TableCell align="center">Comprobante</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{transferenciaList.map((t) => (
								<TableRow key={t.id}>
									<TableCell>{t.cliente}</TableCell>
									<TableCell align="center">{t.creditoId}</TableCell>
									<TableCell align="center">
										{ENTIDADES[t.entidadBancaria] ?? '-'}
									</TableCell>
									<TableCell align="center">
										{moment(t.fechaPago).format('LT')}
									</TableCell>
									<TableCell align="center">
										{formatter.format(t.totalRecibido)}
									</TableCell>
									<TableCell align="center">
										{t.comprobante ? (
											<IconButton
												style={{ color: '#2979ff' }}
												onClick={() =>
													verComprobante(t.comprobante.imageFullPath)
												}
											>
												<FontAwesomeIcon icon={faImage} />
											</IconButton>
										) : null}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>

				<Stack direction="row" justifyContent="space-between">
					<Typography fontWeight="bold">Total Transferencias</Typography>
					<Typography fontWeight="bold" color="#00a152">
						{formatter.format(total)}
					</Typography>
				</Stack>
			</Stack>

			<PreviewModal
				openModal={previewOpen}
				selectedImage={selectedImage}
				setOpenModal={setPreviewOpen}
				setSelectedImage={setSelectedImage}
			/>
		</MediumModal>
	);
};

export default TransferenciasGestorModal;
